import { View } from "react-native";
import { Text } from "react-native-paper";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../types";
import { useNavigation } from "@react-navigation/native";

type PaymentChoiceModalProps = {
  onDismiss(): void;
  visible: boolean;
};

const PaymentChoiceModal = ({ onDismiss, visible }: PaymentChoiceModalProps) => {
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  return (
    <Modal title="Choose How You Will Pay" onDismiss={onDismiss} visible={visible}>
      <View className="pb-8">
        <View className="p-6">
          <Text className="text-large-tight font-700 text-ink-dark">Self-Payment</Text>
          <Text className="my-6 text-regular-normal text-ink-dark">
            In the next step, you'll review your dues payment summary and select a payment method.
          </Text>
          <Button
            mode="contained"
            onPress={() => {
              navigation.navigate("DuesSummary");
              onDismiss();
            }}
            className="w-full"
          >
            Review and Pay Now
          </Button>
        </View>

        <View className="p-6 border-t border-sky-light">
          <Text className="text-large-tight font-700 text-ink-dark">Request Proxy Payment</Text>
          <Text className="my-6 text-regular-normal text-ink-dark">
            In the next step, you'll enter your proxy's information and send them a payment request.
          </Text>
          <Button
            mode="outlined"
            onPress={() => {
              navigation.navigate("AssignProxy");
              onDismiss();
            }}
            className="w-full"
          >
            Assign Proxy
          </Button>
        </View>
      </View>
    </Modal>
  );
};

export default PaymentChoiceModal;
